<template>
	<div class="sidebar">
		<div class="sidebar__brand">
			<img src="@/assets/hiq-white.svg" alt="hiq logo" />
		</div>
		<nav class="sidebar__nav">
			<SidebarItem
				class="sidebar__nav__item"
				v-for="link in links"
				:key="link.name"
				v-bind="link"
				@click.native="$emit('navigate')"
			/>
		</nav>
		<User invert />
	</div>
</template>

<script>
import IconCurrent from 'mdi-vue/Star'
import IconCreate from 'mdi-vue/Pencil'
import IconManage from 'mdi-vue/ViewList'
import IconArchive from 'mdi-vue/Archive'
import IconAccountMultiple from 'mdi-vue/AccountMultiple'
import IconModeration from 'mdi-vue/Vote'
import IconBlocked from 'mdi-vue/Cancel'
import IconSettings from 'mdi-vue/Settings'
import IconLogout from 'mdi-vue/Logout'
import SidebarItem from '@/components/admin/SidebarItem'
import User from '@/components/admin/User'

const LINKS = [
	{ name: 'Current Campaign', icon: IconCurrent, badge: true },
	{ name: 'Create Campaign', icon: IconCreate, admin: true },
	{ name: 'Manage Campaigns', icon: IconManage, admin: true },
	{ name: 'Archived Campaigns', icon: IconArchive, admin: true },
	{ name: 'Vote Moderation', icon: IconModeration },
	{ name: 'Blocked IP Addresses', icon: IconBlocked },
	{ name: 'Global Settings', icon: IconSettings, admin: true },
	{ name: 'Admin Accounts', icon: IconAccountMultiple, admin: true },
	{ name: 'Log Out', icon: IconLogout }
]

export default {
	name: 'sidebar',
	computed: {
		links() {
			// Add badges and filter out non-accessible links
			const badge = this.$store.state.api.pendingSubmissions
			const isAdmin = this.$store.getters['auth/isAdmin']

			return LINKS.reduce((acc, link) => {
				// If not admin, skip this link
				if (link.admin && !isAdmin) return acc
				// Append relevant badges
				const badged = link.badge ? { ...link, badge } : link
				// Return links
				return [...acc, badged]
			}, [])
		}
	},
	components: {
		SidebarItem,
		User
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/mq';

.sidebar {
	$pad: 1.5rem;

	display: flex;
	flex-direction: column;
	width: 18rem;
	height: 100%;
	background-color: $blue-48;
	padding: 0 $pad;
	z-index: 100;

	&__brand {
		height: 5.5rem;
		padding: $pad 0;
		border-bottom: 1px solid $white;

		img {
			height: 100%;
		}
	}

	&__nav {
		flex-grow: 1;
		margin-top: $pad;
	}

	.user {
		margin: $pad 0;
	}

	@include mq(md) {
		.user {
			display: none;
		}
	}

	@include mq(lg) {
		&__nav__item {
			margin-right: -$pad;
		}
	}
}
</style>
